import { COMPONENTS, DeepPartial, HistoryConfig } from '@empathybroker/ebx-gluon';

export const MOBILE_HISTORY: DeepPartial<HistoryConfig> = {
  components: {
    container: 'CdlSuggestions',
    item: 'CdlHistorySuggestion',
    toggle: COMPONENTS.PURE.SimpleSlideToggle
  },
  queryHistorySize: 4
};
